<div>
    <form [formGroup]="form">
        <div class="page-title">
            <h1>Add Shipment
            </h1>
        </div>
        <div class="page-body">
            <div>
                <mat-accordion #accordion="matAccordion" [multi]="true">
                    <mat-expansion-panel [expanded]="true" formGroupName="fromAddress">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <h4>From Address</h4>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    Note: <a (click)="fillStoreAddress()">Click here to fill Store Address</a>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Country *</label>
                                        <ng-select [items]="countryList" bindLabel="name" bindValue="code"
                                            (change)="onChange($event,0)" formControlName="countryCode"></ng-select>
                                        <div
                                            *ngIf="form.get('fromAddress.countryCode').touched && !form.get('fromAddress.countryCode').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.countryCode').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">State/Province *</label>
                                        <ng-select [items]="statesList" bindLabel="name" bindValue="code"
                                            formControlName="stateProvince"></ng-select>
                                        <div
                                            *ngIf="form.get('fromAddress.stateProvince').touched && !form.get('fromAddress.stateProvince').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.stateProvince').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">City *</label>
                                        <!-- <ng-select [items]="cityList" bindLabel="name" bindValue="name"
                                            formControlName="cityTown"></ng-select> -->

                                        <input type="text" class="form-control" formControlName="cityTown">
                                        <div
                                            *ngIf="form.get('fromAddress.cityTown').touched && !form.get('fromAddress.cityTown').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.cityTown').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Postal Code *</label>
                                        <input type="text" class="form-control" placeholder="12345" mask="00000"
                                            formControlName="postalCode">
                                        <div
                                            *ngIf="form.get('fromAddress.postalCode').touched && !form.get('fromAddress.postalCode').valid">
                                            <div *ngFor="let validation of validationMessages.po" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.postalCode').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 1 *</label>
                                        <input type="text" class="form-control" formControlName="addressLine1">
                                        <div
                                            *ngIf="form.get('fromAddress.addressLine1').touched && !form.get('fromAddress.addressLine1').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.addressLine1').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 2</label>
                                        <input type="text" class="form-control" formControlName="addressLine2">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 3</label>
                                        <input type="text" class="form-control" formControlName="addressLine3">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Name *</label>
                                        <input type="text" class="form-control" formControlName="name">
                                        <div
                                            *ngIf="form.get('fromAddress.name').touched && !form.get('fromAddress.name').valid">
                                            <div *ngFor="let validation of validationMessages.name" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.name').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Company *</label>
                                        <input type="text" class="form-control" formControlName="company">
                                        <div
                                            *ngIf="form.get('fromAddress.company').touched && !form.get('fromAddress.company').valid">
                                            <div *ngFor="let validation of validationMessages.name" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.company').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Phone *</label>
                                        <input type="text" class="form-control" placeholder="123-123-1234"
                                            mask="000-000-0000" formControlName="phone">
                                        <div
                                            *ngIf="form.get('fromAddress.phone').touched && !form.get('fromAddress.phone').valid">
                                            <div *ngFor="let validation of validationMessages.contactNumber"
                                                class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.phone').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Email *</label>
                                        <input type="text" class="form-control" formControlName="email">
                                        <div
                                            *ngIf="form.get('fromAddress.email').touched && !form.get('fromAddress.email').valid">
                                            <div *ngFor="let validation of validationMessages.email" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.email').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group mt-5">
                                        <input type="checkbox" formControlName="residential" id="fromRes">
                                        <label for="fromRes" style="margin-left: 5px;"> Residential</label>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </mat-expansion-panel>
                    <mat-expansion-panel formGroupName="toAddress">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <h4>To Address</h4>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>

                            <div class="row">

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Country *</label>
                                        <ng-select [items]="countryList" bindLabel="name" bindValue="code"
                                            (change)="onChange($event,1)" formControlName="countryCode"></ng-select>
                                        <div
                                            *ngIf="form.get('toAddress.countryCode').touched && !form.get('toAddress.countryCode').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.countryCode').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">State/Province *</label>
                                        <ng-select [items]="statesListTo" bindLabel="name" bindValue="code"
                                            formControlName="stateProvince"></ng-select>
                                        <div
                                            *ngIf="form.get('toAddress.stateProvince').touched && !form.get('toAddress.stateProvince').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.stateProvince').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">City *</label>
                                        <!-- <ng-select [items]="cityListTo" bindLabel="name" bindValue="code"
                                            formControlName="cityTown"></ng-select> -->
                                        <input type="text" class="form-control" formControlName="cityTown">
                                        <div
                                            *ngIf="form.get('toAddress.cityTown').touched && !form.get('toAddress.cityTown').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.cityTown').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Postal Code *</label>
                                        <input type="text" class="form-control" placeholder="12345" 
                                            formControlName="postalCode">
                                        <div
                                            *ngIf="form.get('toAddress.postalCode').touched && !form.get('toAddress.postalCode').valid">
                                            <div *ngFor="let validation of validationMessages.po" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.postalCode').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 1 *</label>
                                        <input type="text" class="form-control" formControlName="addressLine1">
                                        <div
                                            *ngIf="form.get('toAddress.addressLine1').touched && !form.get('toAddress.addressLine1').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.addressLine1').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 2</label>
                                        <input type="text" class="form-control" formControlName="addressLine2">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Address 3</label>
                                        <input type="text" class="form-control" formControlName="addressLine3">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Name *</label>
                                        <input type="text" class="form-control" formControlName="name">
                                        <div
                                            *ngIf="form.get('toAddress.name').touched && !form.get('toAddress.name').valid">
                                            <div *ngFor="let validation of validationMessages.name" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.name').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Company *</label>
                                        <input type="text" class="form-control" formControlName="company">
                                        <div
                                            *ngIf="form.get('toAddress.company').touched && !form.get('toAddress.company').valid">
                                            <div *ngFor="let validation of validationMessages.name" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.company').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Phone *</label>
                                        <input type="text" class="form-control" placeholder="123-123-1234"
                                            mask="000-000-0000" formControlName="phone">
                                        <div
                                            *ngIf="form.get('toAddress.phone').touched && !form.get('toAddress.phone').valid">
                                            <div *ngFor="let validation of validationMessages.contactNumber"
                                                class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('toAddress.phone').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Email *</label>
                                        <input type="text" class="form-control" formControlName="email">
                                        <div
                                            *ngIf="form.get('fromAddress.email').touched && !form.get('fromAddress.email').valid">
                                            <div *ngFor="let validation of validationMessages.email" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('fromAddress.email').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group mt-5">
                                        <input type="checkbox" formControlName="residential" id="toRes">
                                        <label for="toRes" style="margin-left: 5px;"> Residential</label>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="form.get('fromAddress.countryCode').value != form.get('toAddress.countryCode').value">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <h4>Items Info (Customs) </h4>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="row">
                                <div class="col-md-12">
                                    
                                    <button class="btn btn-primary"
                                        (click)="createFormArray()">Add</button>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Quantity</th>
                                                <th>Description</th>
                                                <th>Weight (Ounces)</th>
                                                <th>Unit Price</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="itemsInfo" >
                                            <tr *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i">
                                                <td>
                                                    <div class="form-group">
                                                        <input type="number" class="form-control" formControlName="quantity">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" formControlName="description">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="number" class="form-control" formControlName="weight">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="number" class="form-control" formControlName="unitPrice">
                                                    </div>
                                                </td>
                                                <td>
                                                    <button class="btn btn-danger" (click)="removeItem(i)">Remove</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Description</label>
                                        <input type="number" class="form-control" formControlName="description">
                                        <div
                                            *ngIf="form.get('customsEx.description').touched && !form.get('customsEx.description').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('customsEx.description').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Quantity</label>
                                        <input type="number" class="form-control" formControlName="quantity">
                                        <div
                                            *ngIf="form.get('customsEx.quantity').touched && !form.get('customsEx.quantity').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('customsEx.quantity').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Weight * (Ounces)</label>
                                        <input type="number" class="form-control" formControlName="weight">
                                        <div
                                            *ngIf="form.get('customsEx.weight').touched && !form.get('customsEx.weight').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue"
                                                class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('customsEx.weight').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Price * </label>
                                        <input type="number" class="form-control" formControlName="unitPrice">
                                        <div
                                            *ngIf="form.get('customsEx.unitPrice').touched && !form.get('customsEx.unitPrice').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue"
                                                class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('customsEx.unitPrice').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </ng-template>
                    </mat-expansion-panel>
                    <mat-expansion-panel formGroupName="parcel">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <h4>Parcel</h4>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="row">
                                <!-- <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Dimension Unit</label>
                                        <ng-select [items]="dimUnits" bindLabel="name" bindValue="id"
                                            formControlName="dimUnit"></ng-select>
                                        <div
                                            *ngIf="form.get('parcel.dimUnit').touched && !form.get('parcel.dimUnit').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.dimUnit').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Weight Unit</label>
                                        <ng-select [items]="weightUnits" bindLabel="name" bindValue="id"
                                            formControlName="weightUnit"></ng-select>
                                        <div
                                            *ngIf="form.get('parcel.weightUnit').touched && !form.get('parcel.weightUnit').valid">
                                            <div *ngFor="let validation of validationMessages.value" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.weightUnit').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Height</label>
                                        <input type="number" class="form-control" formControlName="height">
                                        <div
                                            *ngIf="form.get('parcel.height').touched && !form.get('parcel.height').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.height').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Width</label>
                                        <input type="number" class="form-control" formControlName="width">
                                        <div
                                            *ngIf="form.get('parcel.width').touched && !form.get('parcel.width').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.width').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Length</label>
                                        <input type="number" class="form-control" formControlName="length">
                                        <div
                                            *ngIf="form.get('parcel.length').touched && !form.get('parcel.length').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue" class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.length').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Weight * (Ounces)</label>
                                        <input type="number" class="form-control" formControlName="weight">
                                        <div
                                            *ngIf="form.get('parcel.weight').touched && !form.get('parcel.weight').valid">
                                            <div *ngFor="let validation of validationMessages.numberValue"
                                                class="has-danger">
                                                <span class="form-control-feedback"
                                                    *ngIf="form.get('parcel.weight').hasError(validation.type) ">
                                                    {{validation.message}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <p>Note: Please select box size (Unit: Inches)</p>
                                    <div class="col-md-3" *ngFor="let items of boxSizes">
                                        <div class="boxsizeCard"
                                            [ngClass]="{'selected': selectedBoxSize?.id == items.id}"
                                            (click)="selectBoxSize(items)">
                                            <div class="name">{{items.id}} ({{items.parcelTypeName}})</div>
                                            <div class="desc">Length: <b>{{items.length}}</b></div>
                                            <div class="desc">Width: <b>{{items.width}}</b></div>
                                            <div class="desc">Height: <b>{{items.height}}</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </mat-expansion-panel>

                    <!-- <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <h4>Other</h4>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Shipment Date</label>
                                        <input class="form-control" type="date" formControlName="dateOfShipment">
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </mat-expansion-panel> -->
                </mat-accordion>
                <div class="row">
                    <div class="col-md-12 text-center mt-5 mb-5">
                        <button class="btn btn-primary" [disabled]="!form.valid"
                            (click)="save();accordion.closeAll()">Get
                            Rates</button>
                        <label class="d-block" *ngIf="!form.valid">Please fill mandatory fields (*) to enable this button</label>
                    </div>
                </div>
                <div class="row" *ngIf="rateList.length>0">
                    <div class="col-md-8 offset-md-2">
                        <table class="rateTable">
                            <thead>
                                <tr>
                                    <th>Carrier</th>
                                    <th>Parcel Type</th>
                                    <th>Estimated Delivery date</th>
                                    <th>Service</th>
                                    <th>Guarantee</th>
                                    <th>Total Charges</th>
                                    <th>Select</th>
                                </tr>
                            <tbody>
                                <tr *ngFor="let items of rateList">
                                    <td> {{items.carrier}}</td>
                                    <td>{{items.parcelType}}</td>
                                    <td>
                                        {{items.deliveryCommitment.deliveryDateTime}}</td>
                                    <td> {{
                                        items.serviceId== "UGA" ? "USPS Ground Advantage" :
                                        items.serviceId== "PM" ?  "USPS Priority Mail" :
                                        items.serviceId== "GRD" ? "UPS Ground" :
                                        items.serviceId== "2DA" ? "UPS 2nd Day Air" :
                                        items.serviceId== "NDA_SVR" ? "UPS Next Day Air Saver" :items.serviceId    
                                    }}</td>
                                    <td> {{items.deliveryCommitment.guarantee}}</td>
                                    <td>${{items.totalCarrierCharge | number : '1.2-2'}}</td>
                                    <td><input type="radio" class="cusRadio" name="radio" [value]="items"
                                            [(ngModel)]="selectedRate" [ngModelOptions]="{standalone: true}">
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-4 offset-md-2 mt-5" *ngIf="selectedRate">
                        <div class="form-group">
                            <label for="">Shipment Date</label>
                            <input class="form-control" type="date" [(ngModel)]="shipmentDate"
                                [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>
                    
                    <div class="col-md-4 mt-5" *ngIf="selectedRate">
                        <div class="form-group">
                            <label for="">Sale Order No.</label>
                            <input class="form-control" type="text" [(ngModel)]="soNo"
                                [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>
                    <div class="col-md-12 text-center mb-5" *ngIf="selectedRate && shipmentDate">
                        <button class="btn btn-primary" (click)="check()" [disabled]="!form.valid"> Create
                            Shipment</button>
                    </div>
                </div>
            </div>
        </div>
    </form>

</div>